exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#networkcontainer {\n  padding: 15px;\n  height: 600; }\n  #networkcontainer .vca-grid {\n    margin-top: 34px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/modules/networking/networking-vc/networks/listing/network-listing.scss
// module id = PMBS
// module chunks = 0